

import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { UseCaseBrief } from '../entities/useCaseChat/UseCaseBrief';
import { getUseCaseService } from '../services/UseCaseService';


export interface IDashboardState {
  useCaseBriefs: UseCaseBrief[];

  isLoadingUseCaseBriefs: boolean;
  loadUseCaseBriefs: (inBackground?: boolean) => Promise<UseCaseBrief[]>;
  deleteUseCase(useCaseChatId: string): Promise<void>;
}

export class DashboardStore {
  static useDashboardStore = create<IDashboardState>()(  
      devtools(
        subscribeWithSelector(
          (set, get) => {
            return {
              useCaseBriefs: [],
              isLoadingUseCaseBriefs: true,

              /** Polling tries to update the status constantly. If the flag `inBackground` is true, the loading indicator is not shown. */
              async loadUseCaseBriefs(inBackground: boolean = false): Promise<UseCaseBrief[]> {
                
                if (!inBackground) {
                  set({ isLoadingUseCaseBriefs: true });
                }

                try{
                  const useCaseService = getUseCaseService();
                  const briefs = await useCaseService.getUseCases();
                  set({ useCaseBriefs: briefs });

                }catch(error){
                  console.error("Error loading use case briefs:", error);
                  set({ useCaseBriefs: [] });
                }finally{
                  set({ isLoadingUseCaseBriefs: false });
                }

                return get().useCaseBriefs;
              },


              async deleteUseCase(useCaseChatId: string): Promise<void> {
                const useCaseService = getUseCaseService();
                try {
                  await useCaseService.deleteUseCase(useCaseChatId);
                  
                  await get().loadUseCaseBriefs(); 
                 

                } catch (error) {
                  console.error("Error deleting use case:", error);
                  throw new Error("Unable to delete use case");
                }
              }
            };
          }// end of (set,get) 
        ),// end of subscribeWithSelector 
        { name: 'DashboardStore' }
      )// end of devtools
  ); // end of create

}


